import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Card, CardBody, Col, Container, CardHeader, Row } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';

import BreadCrumb from 'Components/Common/BreadCrumb';
import DeleteModalMulti from 'Components/Common/DeleteModal';
// import DeleteModal from 'Components/Common/DeleteModal';
// import { isEmpty } from 'lodash';

// Export Modal
// import ExportCSVModal from 'Components/Common/ExportCSVModal';

import Loader from 'Components/Common/Loader';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { RootState } from 'slices';
// import { createSortableHeader } from 'Components/pos2u/CreateSortableHeader';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import ModalBackdropNotFound from 'Components/pos2u/ModalBackdropNotFound';

import {
  resetTagForm,
  setActiveTagIndex,
  setCurrentPage,
  setEntriesPerPage,
  setInputPageValue,
  setIsEditTag,
  setPageFilters,
  setTagEditKey,
  setTagModalOpen,
  setTagValues,
} from 'slices/tags/reducer';
import { useDispatch } from 'react-redux';
import { Tag, TagSearchFilters } from 'types/tag/TagTypes';
import { deleteMultiTags, getTags } from 'services/tagService';

import TagTable from './TagTable';
import { createSortableHeader } from 'Components/pos2u/CreateSortableHeader';
import TagModal from './TagModal';
import { toCapitalCase } from 'utils/common/String';
import {
  ActiveStatusOptions,
  TagActionButtons,
  TagButtonIconSize,
} from 'pages/Tags/TagConstants';
import StatusBadge from 'Components/pos2u/StatusBadge';
import MainAddButton from 'Components/pos2u/Buttons/MainAddButton';
import IconActionButton from 'Components/pos2u/Buttons/IconActionButton';
import { FaRegPenToSquare } from 'react-icons/fa6';
import MainDeleteButton from 'Components/pos2u/Buttons/MainDeleteButton';

const TagsPage = () => {
  const { t } = useTranslation();
  // const history = useNavigate();
  const dispatch = useDispatch();

  const layoutState = useSelector((state: RootState) => state.Layout);
  const { layoutModeType } = layoutState;
  const isDarkMode = layoutModeType === 'dark';

  const infoState = useSelector((state: RootState) => state.Info);
  const { merchant, isMerchantLoaded } = infoState;

  const TagsState = useSelector((state: RootState) => state.Tags);
  const { PageDetails, PageFilters } = TagsState;

  const columnHelper = createColumnHelper<Tag>();

  const [isNotFound, setIsNotFound] = useState(false);
  const [tagsList, setTagsList] = useState<Tag[]>([]);
  const [tagsTotal, setTagsTotal] = useState<number>(0);
  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);

  // const [deleteModal, setDeleteModal] = useState<boolean>(false);
  // const [currentReqName, setCurrentReqName] = useState<string>('');
  // const [currentReqId, setCurrentReqId] = useState<number | null>(null);

  const fetchTags = useCallback(async () => {
    if (!merchant?.id) return;

    setIsLoadSuccess(false);
    try {
      const response = await getTags(
        PageFilters.tagName,
        PageDetails.currentPage + 1,
        PageDetails.entriesPerPage
      );

      if (response) {
        const { message, error_code, data } = response;
        if (message === 'OK' && error_code === 0) {
          const { Tags, total } = data;
          setTagsTotal(total);
          setTagsList(Tags);

          setIsNotFound(total === 0);
        } else {
          setTagsTotal(0);
          setTagsList([]);
        }
        setIsLoadSuccess(true);
      } else {
        console.error('No response data returned');
        setTagsTotal(0);
        setTagsList([]);
        setIsLoadSuccess(true);
      }
    } catch (error) {
      console.error('Failed to fetch category data:', error);
      setTagsTotal(0);
      setTagsList([]);
      setIsLoadSuccess(true);
    }
  }, [
    PageDetails.currentPage,
    PageDetails.entriesPerPage,
    PageFilters.tagName,
    merchant,
  ]);

  useEffect(() => {
    if (isMerchantLoaded && merchant?.id) {
      fetchTags();
    }
  }, [fetchTags, merchant, isMerchantLoaded]);

  useEffect(() => {
    if (tagsList) {
      setIsLoadSuccess(true);
    } else {
      setIsLoadSuccess(false);
    }
  }, [tagsList]);

  // const deleteTag = useCallback(
  //   async (id: string) => {
  //     try {
  //       const response: any = await deleteTagById(id);
  //       console.log(response);
  //       if (response) {
  //         const { message, error_code } = response;
  //         if (message === 'OK' && error_code === 0) {
  //           toast.success('Tag Deleted Successfully', { autoClose: 3000 });
  //           fetchTags();
  //         } else {
  //           toast.error(message, { autoClose: 3000 });
  //         }
  //       } else {
  //         toast.error('No response data returned', { autoClose: 3000 });
  //         console.error('No response data returned');
  //       }
  //     } catch (error) {
  //       console.log(error);
  //       toast.error('Unexpected error occurred. Please try again.', {
  //         autoClose: 3000,
  //       });
  //     }
  //   },
  //   [fetchTags]
  // );

  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);

  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState<
    number[]
  >([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] =
    useState<boolean>(false);
  const [isCheckAll, setIsCheckAll] = useState<boolean>(false);

  const deleteMultiple = async () => {
    const checkall = document.getElementById('checkBoxAll') as HTMLInputElement;

    if (selectedCheckBoxDelete && selectedCheckBoxDelete.length > 0) {
      const response: any = await deleteMultiTags(selectedCheckBoxDelete);
      const { message, error_code } = response;
      if (message === 'OK' && error_code === 0) {
        toast.success('Tag Deleted Successfully', { autoClose: 3000 });
        fetchTags();
      } else {
        toast.error(message, { autoClose: 3000 });
      }
    }
    setSelectedCheckBoxDelete([]);
    setIsCheckAll(false);
    setIsMultiDeleteButton(false);
    if (checkall) {
      checkall.checked = false;
    }
  };

  const checkedAllExcludeDisable = useCallback(() => {
    const updatedCheckAllState = !isCheckAll;
    setIsCheckAll(updatedCheckAllState);
    const checkboxes =
      document.querySelectorAll<HTMLInputElement>('.tagCheckBox');

    const tmp: number[] = [];

    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = updatedCheckAllState;
        if (updatedCheckAllState) {
          tmp.push(parseInt(checkbox.value, 10));
        }
      }
    });

    const checkedElements = document.querySelectorAll(
      '.tagCheckBox:checked:not(:disabled)'
    );
    setIsMultiDeleteButton(checkedElements.length > 0);
    setSelectedCheckBoxDelete(tmp);
  }, [isCheckAll]);

  const handleCheckboxChange = (id: number) => {
    const ele = document.querySelectorAll('.tagCheckBox:checked');
    if (ele.length > 0) {
      setIsMultiDeleteButton(true);
    } else {
      setIsMultiDeleteButton(false);
    }

    setSelectedCheckBoxDelete((prevSelected: number[]) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId: number) => selectedId !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  // const inputCreateTagName = useRef<HTMLInputElement>(null);

  // useEffect(() => {
  //   if (isAddingTag) {
  //     inputCreateTagName.current?.focus();
  //   }
  // }, [isAddingTag]);

  const columns: ColumnDef<Tag, any>[] = useMemo(
    () => [
      columnHelper.display({
        id: '#',
        header: () => (
          <input
            type="checkbox"
            id="checkBoxAll"
            data-testid="checkbox-all"
            className="form-check-input"
            onChange={() => checkedAllExcludeDisable()}
            checked={isCheckAll}
          />
        ),
        cell: (cell) => (
          <div id={`checkbox-div-${cell.row.original.id}`} className="w-50">
            <input
              type="checkbox"
              className="tagCheckBox form-check-input"
              value={cell.row.original.id}
              data-testid={`checkbox-tag-${cell.row.original.id}`}
              // onChange={() => dele  teCheckbox()}
              checked={selectedCheckBoxDelete.includes(cell.row.original.id)}
              onChange={() => handleCheckboxChange(cell.row.original.id)}
            />
          </div>
        ),
        meta: {
          style: { width: '5%' },
        },
        enableColumnFilter: false,
        enableSorting: false,
      }),
      columnHelper.accessor('name', {
        header: ({ column }) => (
          <div className="text-center">
            {createSortableHeader(t('Tag Name'), column, '')}
          </div>
        ),
        cell: (cell) => {
          const color = cell.row.original.color;
          return (
            <div className="text-center">
              {' '}
              <span
                className="badge tag-soft-badge"
                style={
                  {
                    fontSize: '0.75rem',
                    // fontSize: '1rem',
                    whiteSpace: 'normal',
                    '--color': color ? color : '#4bb189',
                  } as React.CSSProperties
                }
              >
                {cell.row.original.name}
              </span>
            </div>
          );
        },
        // cell: (cell) => (
        //   <div className="text-center">{cell.row.original.name}</div>
        // ),

        meta: {
          style: {
            minWidth: '100px',
            maxWidth: '200px',
            whiteSpace: 'pre-wrap', // allows line breaks and respects \n
            wordBreak: 'break-word', // breaks long words
          },
        },

        enableColumnFilter: false,
      }),

      columnHelper.display({
        id: 'type',
        header: () => <div className="text-center">{t('Types')}</div>,
        cell: (cell) => (
          <div className="text-center">
            {t(`${toCapitalCase(cell.row.original.type)}`)}
          </div>
        ),

        enableColumnFilter: false,
      }),
      columnHelper.display({
        id: 'description',
        header: () => <div className="text-center">{t('Description')}</div>,
        cell: (cell) => {
          return (
            <div className="text-center">{cell.row.original.description}</div>
          );
        },
        meta: {
          style: {
            minWidth: '100px',
            maxWidth: '200px',
            whiteSpace: 'pre-wrap', // allows line breaks and respects \n
            wordBreak: 'break-word', // breaks long words
          },
        },

        enableColumnFilter: false,
      }),
      columnHelper.display({
        id: 'active',
        header: () => <div className="text-center">{t('Status')}</div>,
        cell: (cell) => {
          const cellVal = cell.row.original.active.toString();
          const statStyle = cellVal === '1' ? 'success' : 'danger';
          const getStatus = ActiveStatusOptions(t).filter(
            (status) => status.value === cellVal
          );
          const statText = getStatus[0]?.label || '';
          return (
            <div className="text-center">
              <StatusBadge statusStyle={statStyle} statusText={statText} />
            </div>
          );
        },
        meta: {
          style: {
            minWidth: '100px',
            maxWidth: '200px',
            whiteSpace: 'pre-wrap', // allows line breaks and respects \n
            wordBreak: 'break-word', // breaks long words
          },
        },

        enableColumnFilter: false,
      }),
      columnHelper.display({
        id: 'action',
        header: () => <div className="text-center">{'Action'}</div>,
        cell: (cell) => {
          // const ID = cell.row.original.id;
          const tag = cell.row.original;
          // const tagName = document.getElementById(
          //   `tagName-${ID}`
          // ) as HTMLInputElement;
          const initialValues = {
            name: tag.name,
            type: tag.type,
            description: tag.description,
            color: tag.color,
            active: tag.active.toString(),
          };

          return (
            <div className="d-flex justify-content-center">
              <ul className="list-inline hstack gap-2 mb-0">
                <li className="list-inline-item">
                  <div className="d-flex gap-2">
                    {/* <button
                      type="button"
                      className="btn btn-info btn-xl"
                      id={`edit-btn-${cell.row.original.id}`}
                      onClick={() => {
                        dispatch(setTagModalOpen(true));
                        dispatch(setActiveTagIndex(tag.id));
                        dispatch(setTagValues(initialValues));
                        dispatch(setTagEditKey(tag.id));
                        dispatch(setIsEditTag(true));
                      }}
                      // onClick={() => handleEditClick(cell.row.original.id)}

                      disabled={tagName?.value === ''}
                    >
                      {t('Edit')}
                    </button> */}

                    <IconActionButton
                      id={`edit-btn-${cell.row.original.id}`}
                      onClick={() => {
                        dispatch(setTagModalOpen(true));
                        dispatch(setActiveTagIndex(tag.id));
                        dispatch(setTagValues(initialValues));
                        dispatch(setTagEditKey(tag.id));
                        dispatch(setIsEditTag(true));
                      }}
                      icon={
                        <FaRegPenToSquare fontSize={TagActionButtons.icon} />
                      }
                      title={t('Edit')}
                      height={TagActionButtons.button.height}
                      width={TagActionButtons.button.width}
                    />
                  </div>
                </li>
              </ul>
            </div>
          );
        },
        enableColumnFilter: false,
        enableSorting: false,
      }),
    ],
    [
      dispatch,
      columnHelper,
      t,
      checkedAllExcludeDisable,
      isCheckAll,
      selectedCheckBoxDelete,
    ]
  );

  // Column
  // Export Modal
  // const [isExportCSV, setIsExportCSV] = useState<boolean>(false);

  document.title = t('Tags') + ' | POS2U';

  const totalPages = Math.ceil(tagsTotal / PageDetails.entriesPerPage);

  const handlePageChange = (newPage: number) => {
    dispatch(setCurrentPage(newPage));
  };
  const handleFilterSearchSubmit = (searchFilters: TagSearchFilters) => {
    setIsCheckAll(false);
    setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete([]);
    dispatch(setPageFilters(searchFilters));
    dispatch(setCurrentPage(0));
    fetchTags();
  };

  return (
    <div className="page-content">
      {/* <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={orders}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <ModalBackdropNotFound
        isNotFound={isNotFound}
        setIsNotFound={setIsNotFound}
        message={`${t('Not found for Tags')}`}
        ButtonMsg="OK"
      />
      <DeleteModalMulti
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
        title={t('Delete Tag')}
        message={
          selectedCheckBoxDelete.length === 1
            ? t('SingleDeleteAlertMessage')
            : t('MultiDeleteAlertMessage', {
                items: selectedCheckBoxDelete.length,
              })
        }
        cancelBtnMsg={t('Cancel')}
        confirmBtnMsg={t('Delete')}
      />
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => {
          setDeleteModal(false);
          deleteTag(currentReqId ? currentReqId.toString() : '');
        }}
        onCloseClick={() => setDeleteModal(false)}
        recordId={currentReqName}
        title={t('Delete Tag?')}
        message={t('Confirm to delete tag')}
        cancelBtnMsg={t('Cancel')}
        confirmBtnMsg={t('Confirm delete')}
      /> */}

      <Container fluid>
        <BreadCrumb title={t('Tag Manager')} />
        <Row>
          <Col lg={12}>
            <Card id="tagList">
              <CardHeader className="card-header border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">{t('Tag List')}</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      {/* <button
                        type="button"
                        className="btn btn-success add-btn"
                        id="add-category-btn"
                        onClick={() => {
                          // setIsAddingTag(!isAddingTag);
                          dispatch(resetTagForm());
                          dispatch(setTagModalOpen(true));
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i>
                        {t('Create Tag')}
                      </button> */}
                      <MainAddButton
                        to=""
                        label={t('Create Tag')}
                        id="add-tag-btn"
                        onClick={() => {
                          // setIsAddingTag(!isAddingTag);
                          dispatch(resetTagForm());
                          dispatch(setTagModalOpen(true));
                        }}
                        soft={true}
                      />{' '}
                      {/* <button
                        type="button"
                        className="btn btn-info"
                        onClick={() => setIsExportCSV(true)}
                      >
                        <i className="ri-file-download-line align-bottom me-1"></i>{' '}
                        Export
                      </button>{' '} */}
                      {isMultiDeleteButton && (
                        // <button
                        //   className="btn btn-soft-danger"
                        //   data-testid="multi-delete-button"
                        //   onClick={() => setDeleteModalMulti(true)}
                        // >
                        //   <RiDeleteBin2Line size={TagButtonIconSize} />
                        // </button>
                        <MainDeleteButton
                          onClick={() => setDeleteModalMulti(true)}
                          iconSize={TagButtonIconSize}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  {isLoadSuccess ? (
                    <TagTable
                      columns={columns}
                      data={tagsList || []}
                      customPageSize={PageDetails.entriesPerPage}
                      divClass="table-responsive table-card mb-1 mt-0"
                      tableClass="align-middle table-nowrap"
                      theadClass={`table-${
                        isDarkMode ? 'dark' : 'light'
                      } text-muted text-uppercase`}
                      // thClass="text-center"
                      // tdClass="text-center"
                      isTagQuery={true}
                      selectedCheckBoxDelete={selectedCheckBoxDelete.length}
                      TotalData={tagsTotal}
                      totalPages={totalPages}
                      setEntriesPerPage={setEntriesPerPage}
                      currentPage={PageDetails.currentPage}
                      handlePageChange={handlePageChange}
                      handleSearchFiltersSubmit={handleFilterSearchSubmit}
                      initialFilters={PageFilters}
                      inputPageValue={PageDetails.inputPageValue}
                      setInputPageValue={setInputPageValue}
                    />
                  ) : (
                    <Loader />
                  )}
                </div>
                <ToastContainer closeButton={false} limit={1} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <TagModal fetchTags={fetchTags} />
    </div>
  );
};

export default TagsPage;
